export default __webpack_public_path__ + "110ab178feb11f37d727eba3686fe11f.png";